
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Profile {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'superadmin' | 'member';
  created_at: string;
}

interface ImpersonateDialogProps {
  user: Profile | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isImpersonating: boolean;
}

export const ImpersonateDialog = ({
  user,
  isOpen,
  onOpenChange,
  onConfirm,
  isImpersonating
}: ImpersonateDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirm Impersonation</DialogTitle>
          <DialogDescription>
            Are you sure you want to impersonate {user?.first_name} {user?.last_name}?
            <br />
            <span className="text-sm text-muted-foreground mt-2 block">
              You will be redirected to the home page as this user. You can stop impersonation from the navigation bar.
            </span>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button 
            onClick={onConfirm}
            disabled={isImpersonating}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {isImpersonating ? 'Starting...' : 'Start Impersonation'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
